import { useEffect, useState } from "react";
import classNames from "../../../utils/classNames";
import formatDateTime from "../../../utils/formatDateTime";
import { DateTime } from 'luxon';

export default function MonthlyIntervalSelector({ setValue, getValues }) {
  const [refresh, setRefresh] = useState(false);

  const days = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];

  const handleDays = (day) => {
    let currentMonthdays = getValues("trigger.monthDays");
    console.log(currentMonthdays)
    if (!currentMonthdays) currentMonthdays = [];

    //add on weekday if not there, otherwise remove
    if (currentMonthdays?.includes(day)) {
      setValue("trigger.monthDays", currentMonthdays.filter(d => d !== day));
    } else {

      if (currentMonthdays == []) {
        setValue("trigger.monthDays", [day]);
      } else {
        currentMonthdays.push(day);
        setValue("trigger.monthDays", currentMonthdays);
      }
    }

    setRefresh(!refresh);
  }

  useEffect(() => {
  }, [refresh])

  const dayStyling = (day) => {
    const currentWeekdays = getValues("trigger.monthDays");

    return classNames(
      "w-8 h-8 rounded-full border border-gray-700 font-bold",
      (currentWeekdays && currentWeekdays.includes(day)) ? "bg-gray-700 text-white" : ""
    );
  };

  return (
    <div className="mt-6 flex flex-col items-center gap-x-2">

      <div className="grid grid-cols-15 gap-2">
        {days.map((day, index) => (
          <button key={index} type="button" onClick={() => handleDays(day)} className={dayStyling(day)} >
            {day}
          </button>
        ))}
      </div>

      {getValues("trigger.startDateTime") && (
        <>
          <div>
            @ {formatDateTime(getValues("trigger.startDateTime"), DateTime.TIME_SIMPLE)}
          </div>
          <div className="text-sm text-gray-600">
            (From Start Date and Time)
          </div>
        </>
      )}

    </div>
  )

}